import {Injectable} from '@angular/core';
import {BaseModelService} from '../base-model.service';

@Injectable({
  providedIn: 'root'
})
export class BreakdownsTypesModelService extends BaseModelService {

  tableName = 'yu_v3_breakdowns_types';

}
